import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProgramRecord } from "@/savaradio/common";
export const initialLoading = {
  create: false,
  delete: false,
  update: false,
  get: false,
  find: false
}
export type IsLoading = Record<keyof typeof initialLoading, boolean>

const initialState: { value?: ProgramRecord[], isLoading: IsLoading } = { isLoading: initialLoading }

const programRecordSlice = createSlice({
  initialState,
  name: "program_record_slice",
  reducers: {
    reset: (state, action: PayloadAction<ProgramRecord[] | undefined>) => {
      state.value = action.payload
    },
    append: (state, action: PayloadAction<ProgramRecord>) => {
      if (!state.value) state.value = [action.payload]
      if (
        state.value &&
        !state.value.some(item => item._id === action.payload._id)
      ) state.value = state.value.concat(action.payload)
    },
    pop: (state, action: PayloadAction<ProgramRecord>) => {
      if (!!state.value) state.value = state.value.filter(program_record => program_record._id !== action.payload._id)
    },
    merge: (state, action: PayloadAction<ProgramRecord>) => {
      if (!!state.value) state.value = state.value.map(program_record => (
        program_record._id === action.payload._id ?
          action.payload : program_record
      ))
    },
    setLoading: (state, action: PayloadAction<Partial<IsLoading>>) => {
      state.isLoading = {
        ...state.isLoading,
        ...action.payload
      }
    }
  }
})

export const { append, reset, merge, pop, setLoading } = programRecordSlice.actions
export const program_record_slice = programRecordSlice.reducer